// Animation.js
import * as React from 'react';

export default function Animation({ loading }) {
  return (
<div className="animation-modal" style={{ display: loading ? 'flex' : 'none' }}>
  <ul className="animation-ul">
    <li className="animation-li"></li>
    <li className="animation-li"></li>
    <li className="animation-li"></li>
    <li className="animation-li"></li>
    <li className="animation-li"></li>
  </ul>
  <p className="animation-p">Loading...</p>
</div>

  );
}
